module.exports = __webpack_public_path__ + "img/xzlf.1473eb40.png";